export default {
  add_items: 'Añadir artículos',
  remove_items: 'Eliminar artículos',
  place_order: 'Realizar pedido',
  proceed_to_payment: 'Continuar al pago',
  go_to_menu: 'Ir al menú',

  toasts: {
    input_errors_found: 'Hay algunos problemas con la información de tu pedido',
  },

  error_messages: {
    internal_error: {
      title: 'Pedido fallido 😔',
      description:
        'Lamentablemente, hubo un problema inesperado con tu pedido; nuestro equipo técnico ya está trabajando en ello 🛠️.',
    },
  },
};
